import { styled } from '@mui/styles';

export const ViewContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(4),
}));

export const CenteredContentContainer = styled(({ children, className }) => (
    <div className={className}>
        <div>{children}</div>
    </div>
))(() => ({
    width: '100%',
    height: '100vh',
    display: 'flex',
    marginTop: '40px',
    '& > div': {
        margin: 'auto',
        textAlign: 'center',
        width: '100%',
    },
}));

export const LeftContentContainer = styled(({ children, className }) => (
    <div className={className}>
        <div>{children}</div>
    </div>
))(() => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    marginBottom: '100px',
    '& > div': {
        margin: 'auto',
        maxWidth: '700px',
        marginBottom: '100px',
        '& > h1': {
            marginBottom: '20px',
        },
        '& > h6': {
            marginTop: '6px',
            marginBottom: '6px',
        },
        '& > div': {
            marginBottom: '20px',
            '& > h6': {
                marginTop: '20px',
                marginBottom: '10px',
            },
            '& > p': {
                marginBottom: '10px',
                '& > ol': {
                    '& > li': {
                        marginBottom: '4px',
                    },
                },
            },
        },
    },
}));
